import { createContext } from 'react';

export const CommonPortalContext = createContext({
  ref: {
    snackbar: {
      current: {
        handleSnackbarClose: () => {},
        handleSnackbarOpen: () => {},
      },
    },
    fsPopup: {
      current: {
        handleFSPopupClose: () => {},
        handleFSPopupOpen: () => {},
      },
    }
  },

  handler: {
    handleSnackbarClose: () => {},
    handleSnackbarOpen: () => {},
    handleFSPopupClose: () => {},
    handleFSPopupOpen: () => {},
  },
});

export const CommonPortalProvider = CommonPortalContext.Provider;
